var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-bottom-margin"},[_c('h1',{staticClass:"header-style"},[_vm._v("\n    Document Uploads\n  ")]),_c('br'),_c('p',{staticClass:"subheader-style"},[_vm._v("\n    Please upload the below documents for completing the process\n  ")]),_c('upload-documents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }